<template>
  <div id="app">
    <!-- header -->
    <Header style="position:fixed;top:0;width: 100%;z-index: 99;"></Header>
    <router-view style="margin-top: 160px;" />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue